import { render } from "./SenderInfoModal.vue?vue&type=template&id=cd772e3a&scoped=true"
import script from "./SenderInfoModal.vue?vue&type=script&lang=js"
export * from "./SenderInfoModal.vue?vue&type=script&lang=js"

import "./SenderInfoModal.vue?vue&type=style&index=0&id=cd772e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd772e3a"]])

export default __exports__